module.exports = __webpack_public_path__ + "img/bin.2635879a.svg";